import { createContext } from 'react';
import type { Dispatch } from 'react';

import { initialAction, initialState } from './initial';

const PaymentGatewayValueContext =
  createContext<typeof initialState>(initialState);

const PaymentGatewayActionContext = createContext<
  Dispatch<typeof initialAction>
>(() => {});

export { PaymentGatewayActionContext, PaymentGatewayValueContext };
